import { render, staticRenderFns } from "./ValidationPhoneModal.vue?vue&type=template&id=40ec1477&scoped=true&"
import script from "./ValidationPhoneModal.vue?vue&type=script&lang=js&"
export * from "./ValidationPhoneModal.vue?vue&type=script&lang=js&"
import style0 from "./ValidationPhoneModal.vue?vue&type=style&index=0&id=40ec1477&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ec1477",
  null
  
)

export default component.exports